export default __webpack_public_path__ + "static/media/background_planet-03_bottom.0ac67f49.jpg";